import React from 'react';
import { func, bool, string } from 'prop-types';
import styles from './RightSideButtons.module.scss';
import MenuButton from '../MenuButton/MenuButton';
import AboutButton from './AboutButton';

const RightSideButtons = ({
  onAboutClick,
  onHelpClick,
  onShareClick,
  showAbout,
  shareText,
  helpText,
  aboutUsText,
  locJP,
}) => (
  <div className={styles.wrapper}>
    <div className={styles.gridItemAbout}>
      {showAbout && <AboutButton onClick={onAboutClick} label={aboutUsText} />}
    </div>
    <div className={styles.gridItemHelp}>
      <MenuButton
        icon="help"
        label={helpText}
        alignBottomLeft
        onClick={onHelpClick}
        locJP={locJP}
      />
    </div>
    <div className={styles.gridItemShare}>
      <MenuButton
        icon="share"
        label={shareText}
        alignBottomRight
        onClick={onShareClick}
        locJP={locJP}
      />
    </div>
  </div>
);

RightSideButtons.propTypes = {
  onAboutClick: func.isRequired,
  onHelpClick: func.isRequired,
  onShareClick: func.isRequired,
  shareText: string.isRequired,
  helpText: string.isRequired,
  aboutUsText: string,
  showAbout: bool,
  locJP: bool,
};

RightSideButtons.defaultProps = {
  showAbout: false,
  aboutUsText: '',
  locJP: false,
};

export default RightSideButtons;
